import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { Module, Imodule } from "../shared/module.model";
import { NotificationService, LoaderService, EVENTO, TOOLTIPS, ICONS, ACTIONS } from "../../../../shared/session/index";
import { ModuleService } from '../shared/module.service';
import { RegularExpressionMessage, RegularExpression, CustomValidators } from '../../../../shared/validation/customvalidation';
import { AplicacionService } from '../../Aplicaciones/shared/aplicacion.service';
import { Aplicacion } from '../../Aplicaciones/shared/aplicacion.model';

@Component({
  selector: 'app-module-edit',
  templateUrl: 'module-edit.component.html'
})

export class ModuleEditComponent implements OnInit {
  @Output() onChangeEvent: EventEmitter<any> = new EventEmitter();
  @Input() data: any;
  @Input() titlePage: string;

  formGrupEditModule: FormGroup;
  buttonGroup: any;
  modules: Imodule;
  nomAccessMaxLength: number;
  descriptionMaxLength: number;
  msgErrorActualizar: string;
  msgErrorGet: string;
  msgSuccessInsert: string;
  msgErrorInsert: string;
  obligatorioMsg: string;
  maxLengthMsg: string;
  accessName: string;
  descripcionMaxLength: number;
  nomAccessPatternMsg: string = RegularExpressionMessage.LETRAS_TILDE_ENIE_MSG;
  nomPathMaxLength: number;
  msgErrorGetAplicaciones: string;

  aplicaciones: Aplicacion[];

  constructor(
    private loaderService: LoaderService,
    private moduleService: ModuleService,
    private notificationService: NotificationService,
    private aplicacionService: AplicacionService,
    public fb: FormBuilder
  ) { }

  ngOnInit() {
    this.buttonGroup = [
      { tooltip: TOOLTIPS.save, icon: ICONS.save, action: ACTIONS.save }
    ];

    this.msgErrorActualizar = 'Error al actualizar datos';
    this.msgErrorGet = 'Error al obtener datos';
    this.msgErrorGetAplicaciones = "Error al listar las aplicaciones";
    this.modules = new Module(0, "", 1, "", true,"", "","", "", "");
    this.setValuesFormBuilder();
    this.listarAplicacionCbo();
    this.obtenerModule(this.data.modules.ID);
  }

  private setValuesFormBuilder() {
    this.formGrupEditModule = this.fb.group({
        moduleName: [this.modules.Name, Validators.compose([
        Validators.required,
        Validators.maxLength(this.nomAccessMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      descripcion: [this.modules.Descripcion, Validators.compose([
        Validators.maxLength(this.descripcionMaxLength),
        CustomValidators.pattern(RegularExpression.LETRAS_TILDE_ENIE_NUMERO)
      ])],
      status: [this.modules.Status],
      aplicacionID: [this.modules.AplicacionID]
    });
  }

  formGrupEditModuleSubmit(event) {
    if (this.formGrupEditModule.invalid)
      return;
    this.modules.Name = event.value.moduleName,
    this.modules.Descripcion = event.value.descripcion,
    this.modules.Status = event.value.status,
    this.modules.AplicacionID = event.value.aplicacionID

    this.actualizarAccess(this.modules);
  }

  changeEvent(modules: Imodule) {
    this.data.modules = {ID : this.modules.ModuleID , Name : this.modules.Name};
    this.onChangeEvent.emit({ evento: EVENTO.consultar, data: this.data });
  }

  private actualizarAccess(modules: Imodule) {
    this.loaderService.show();
    this.moduleService.actualizarModule(modules)
    .subscribe(res => {
      this.changeEvent(modules);
      this.notificationService.successful("Se actualizó satisfactoriamente");
    },
    error => {
      this.notificationService.error(this.msgErrorActualizar);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }

  private obtenerModule(moduleID: number): void {
    this.loaderService.show();
    this.moduleService.obtenerModule(moduleID)
    .subscribe(res => {
      this.modules = res;
    },
    error => {
      this.notificationService.error(this.msgErrorGet);
      throw error;
    },
    () => {
      this.setValuesFormBuilder();
      this.loaderService.hide();
    });
  }

  private listarAplicacionCbo(): void {
    this.loaderService.show();
    this.aplicacionService.listarApplication()
    .subscribe(res => {
      this.aplicaciones = res;
    },
    error => {
      this.notificationService.error(this.msgErrorGetAplicaciones);
      throw error;
    },
    () => {
      this.loaderService.hide();
    });
  }
}
